import type { AuctionCarPagination } from '@autobid/ui/types/Car'
import type { Ref } from 'vue'
import { usePage } from '@autobid/strapi-integration/composable/usePage'
import { getPageType } from '@autobid/ui/composables/car/useCarPageInfo'
import { useCarPaginationLinks } from '@autobid/ui/composables/car/useCarPaginationLinks'
import { useSwipe } from '@autobid/ui/composables/useSwipe'
import { onMounted } from 'vue'

export function useCarSwipe(pagination: Ref<AuctionCarPagination | undefined>) {
  const route = useRoute()
  const router = useRouter()
  const pageType = getPageType(String(route.name))
  const { prefetchPage } = usePage()

  if (
    pageType !== 'details'
    && pageType !== 'barometer'
    && pageType !== 'barometerCurrent'
  ) {
    return
  }

  const data = useCarPaginationLinks(pagination)

  const prefetchBarometerPage = () => {
    if (
      pageType !== 'barometerCurrent'
      || (!data.prevLink.value && !data.nextLink.value)
    ) {
      return
    }

    try {
      prefetchPage({
        slug: 'item',
        draft: false,
        allowEmpty: false,
        ignoreBlacklist: true,
      })
    }
    catch {
      // do nothing
    }
  }

  useSwipe({
    onSwipe: (direction) => {
      if (direction === 'left' && data.nextLink.value) {
        router.push(data.nextLink.value)
      }
      else if (direction === 'right' && data.prevLink.value) {
        router.push(data.prevLink.value)
      }
    },
  })

  onMounted(() => {
    prefetchBarometerPage()
  })

  return data
}
